import React from "react";

function DeleteGrayIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 34 34"
    >
      <g
        id="Group_27831"
        data-name="Group 27831"
        transform="translate(-1856 -281)"
      >
        <circle
          id="Ellipse_2005"
          data-name="Ellipse 2005"
          cx="17"
          cy="17"
          r="17"
          transform="translate(1856 281)"
          fill="#d4e3ed"
        />
        <path
          id="Path_18498"
          data-name="Path 18498"
          d="M14.75,5.4H19V7.1H17.3V18.15a.85.85,0,0,1-.85.85H4.55a.85.85,0,0,1-.85-.85V7.1H2V5.4H6.25V2.85A.85.85,0,0,1,7.1,2h6.8a.85.85,0,0,1,.85.85Zm.85,1.7H5.4V17.3H15.6ZM7.95,9.65h1.7v5.1H7.95Zm3.4,0h1.7v5.1h-1.7ZM7.95,3.7V5.4h5.1V3.7Z"
          transform="translate(1863 288)"
          fill="#596970"
        />
      </g>
    </svg>
  );
}

export default DeleteGrayIcon;
